// import the scss file

import "../scss/bootstrap.scss";
